import React, { useEffect, useRef, useState } from 'react';
import { safeHTML } from '../../../utils/safeHTML';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import { nyTaskContent } from '../../../constants/copyright';
import { useModal } from '../../../hooks/useModal';

const { afterAnswerModal } = nyTaskContent;

const QuizItem = React.forwardRef(function QuizItem(
  { image, text, answers, index, nextStep, setScore, note, note_title, note_image, isMove = false },
  ref,
) {
  const [activeId, setActiveId] = useState(null);
  const [answerId, setAnswerId] = useState();
  const captionRef = useRef();
  const captionSpanRef = useRef();

  const { addModal } = useModal();

  const setAnswerData = (id, i) => {
    setAnswerId(id);
    setActiveId(i);
  };

  const nextStepLogic = (answerId) => {
    const successCallback = () => {
      nextStep();
      setScore(answerId);
    };

    addModal({
      type: 'quizStartModal',
      props: {
        ...afterAnswerModal,
        image: note_image,
        title: note_title,
        description: note,
        goToQuiz: successCallback,
        onClose: successCallback,
      },
    });
  };

  useEffect(() => {
    const caption = captionRef.current;
    const scale = Math.min(1, caption.clientHeight / caption.scrollHeight);
    if (scale < 1) captionSpanRef.current.style.fontSize = `${scale}em`;
  }, []);

  return (
    <div className={`quiz__item quiz__item_simple ${answers?.length > 4 ? 'quiz__item_min' : ''}`} ref={ref}>
      <div className={'quiz__item-image'}>
        <img src={image} alt={''} />
      </div>
      <div className={'quiz__item-block'}>
        <h2 className='quiz__item-title' ref={captionRef}>
          <span ref={captionSpanRef}>{safeHTML(text)}</span>
        </h2>
        <div className={`quiz__item-items`}>
          <ul>
            {answers?.map(({ text, id }, i) => (
              <li key={`li-${i}`}>
                <CustomButton
                  className={classNames(
                    'custom-button_quiz-item quiz__item-option',
                    {
                      'quiz__item-option_active': activeId === i,
                    },
                    { 'quiz__item-option_move custom-button_quiz-item-move': isMove },
                  )}
                  key={`btn-${i}`}
                  text={text}
                  icon={isMove ? 'buttons/quiz-points' : null}
                  onClick={() => setAnswerData(id, i)}
                />
              </li>
            ))}
          </ul>
        </div>
        <CustomButton
          className={classNames('button_quiz-a quiz__item-button', {
            'custom-button_disabled': activeId === null,
          })}
          text={'other.reply'}
          timeout={1000}
          disposable={true}
          disabled={activeId === null}
          onClick={() => nextStepLogic(answerId)}
        />
      </div>
    </div>
  );
});

export default QuizItem;
QuizItem.propTypes = {};
